export default __webpack_public_path__ + "static/media/footer-mobile-slice.fae467b0.svg";